import React from 'react';
import { partners, coreTeam } from '../mock';
import { Award, Briefcase } from 'lucide-react';

const Team = () => {
  return (
    <section id="team" className="py-24 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <span className="caption mb-4 block">
            Our Team
          </span>
          <h2 className="heading-2 mb-6">
            Meet Our Partners
          </h2>
          <p className="body-medium max-w-3xl mx-auto">
            Experienced professionals committed to your financial success
          </p>
        </div>

        {/* Partners Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {partners.map((partner) => (
            <div
              key={partner.id}
              className="bg-white rounded-lg border border-[hsl(var(--border-light))] hover:border-[hsl(var(--primary-blue))] hover:shadow-xl transition-all duration-300 overflow-hidden group"
            >
              {/* Partner Image Placeholder */}
              <div className="h-64 bg-gradient-to-br from-[hsl(var(--primary-blue)/.1)] to-[hsl(var(--bg-light))] flex items-center justify-center">
                <div className="w-24 h-24 bg-[hsl(var(--primary-blue)/.2)] rounded-full flex items-center justify-center">
                  <Briefcase className="text-[hsl(var(--primary-blue))]" size={40} />
                </div>
              </div>

              {/* Partner Info */}
              <div className="p-6">
                <h3 className="heading-5 mb-2">
                  {partner.name}
                </h3>
                <p className="body-small text-[hsl(var(--text-secondary))] mb-1">
                  {partner.qualification}
                </p>
                <p className="caption text-[hsl(var(--primary-blue))] mb-4">
                  {partner.designation}
                </p>
                
                <div className="flex items-center gap-2 mb-4">
                  <Award size={16} className="text-[hsl(var(--primary-blue))]" />
                  <span className="body-small text-[hsl(var(--text-secondary))]">{partner.experience}</span>
                </div>

                <p className="body-small text-[hsl(var(--text-secondary))] mb-4 leading-relaxed">
                  {partner.description}
                </p>

                {/* Achievements */}
                {partner.achievements && (
                  <div className="mt-4 pt-4 border-t border-[hsl(var(--border-light))]">
                    <p className="body-small font-semibold text-[hsl(var(--primary-blue))] mb-2">Key Positions:</p>
                    <ul className="space-y-1">
                      {partner.achievements.map((achievement, idx) => (
                        <li key={idx} className="body-small text-[hsl(var(--text-secondary))] text-sm flex items-start gap-2">
                          <span className="text-[hsl(var(--primary-blue))] mt-1">•</span>
                          <span>{achievement}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Expertise Tags */}
                <div className="mt-4 flex flex-wrap gap-2">
                  {partner.expertise.slice(0, 3).map((skill, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-1 bg-[hsl(var(--primary-blue)/.1)] text-[hsl(var(--primary-blue))] rounded-full text-xs font-medium"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Core Team Section */}
        <div>
          <h3 className="heading-4 mb-8 text-center">Our Core Team</h3>
          <div className="grid md:grid-cols-3 gap-6">
            {coreTeam.map((member, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg border border-[hsl(var(--border-light))] hover:border-[hsl(var(--primary-blue))] hover:shadow-lg transition-all duration-300"
              >
                <h4 className="heading-6 mb-2">
                  {member.name}
                </h4>
                <p className="body-small text-[hsl(var(--text-secondary))] mb-3">
                  {member.qualification}
                </p>
                <p className="caption text-[hsl(var(--primary-blue))] mb-4">
                  {member.experience}
                </p>
                <p className="body-small text-[hsl(var(--text-secondary))] leading-relaxed">
                  {member.expertise}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
